module.exports = __webpack_public_path__ + "img/head_bk.baa55aa8.png";